import React from 'react';
import styled from 'styled-components';

const VideoContainer = styled.section`
  background-color: #0a1a1f;
  padding: 4rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VideoWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  position: relative;
  aspect-ratio: 16/9;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const VideoSection = () => {
  return (
    <VideoContainer>
      <VideoWrapper>
        <iframe 
          loading="lazy" 
          title="Gumlet video player"
          src="https://play.gumlet.io/embed/67ee2f79292035ad5ac10c09"
          style={{
            border: 'none', 
            position: 'absolute', 
            top: 0, 
            left: 0, 
            height: '100%', 
            width: '100%'
          }}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;"
        />
      </VideoWrapper>
    </VideoContainer>
  );
};

export default VideoSection;